import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useBoostCorePermissionStore } from '@/stores/useBoostCorePermissionStore'

export type LayoutMode = 'v1' | 'v2'

const STORAGE_KEY = 'bs2.layoutMode'

export const HOME_PATH_V1 = '/'
export const HOME_PATH_V2 = '/accueil'

function readStored(): LayoutMode {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    return v === 'v2' ? 'v2' : 'v1'
  } catch {
    return 'v1'
  }
}

/**
 * Mode actif (V1 vs V2) — pour l'instant via localStorage.
 * Plus tard : à migrer vers une préférence user persistée backend.
 *
 * `effectiveMode` retombe en V1 si l'utilisateur perd le flag LAYOUT_APY,
 * sans réinitialiser la préférence locale (utile si le flag est temporairement
 * retiré puis remis).
 */
export const useLayoutModeStore = defineStore('layoutMode', () => {
  const boostCoreStore = useBoostCorePermissionStore()
  const mode = ref<LayoutMode>(readStored())

  const effectiveMode = computed<LayoutMode>(() =>
    mode.value === 'v2' && boostCoreStore.hasFlag('LAYOUT_APY') ? 'v2' : 'v1',
  )

  function setMode(next: LayoutMode) {
    mode.value = next
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch {
      // localStorage indisponible (mode privé strict) — on ignore
    }
  }

  function homePathFor(target: LayoutMode): string {
    return target === 'v2' ? HOME_PATH_V2 : HOME_PATH_V1
  }

  return { mode, effectiveMode, setMode, homePathFor }
})
